import { EtaEmitter } from './eta-emitter.enum';
import { DeliveryEventSource } from './delivery-event-source.enum';

export enum DeliveryEtaEventInitiator {
  DRIVER = 'DRIVER',
  DRIVER_VIA_CMA = 'DRIVER_VIA_CMA',
  AUTOMATIC_VIA_CMA = 'AUTOMATIC_VIA_CMA',
  DRIVER_VIA_CICO = 'DRIVER_VIA_CICO',
  AUTOMATIC_VIA_CICO = 'AUTOMATIC_VIA_CICO',
  STATIC_FROM_SAP = 'STATIC_FROM_SAP',
  PGI_FROM_SAP = 'PGI_FROM_SAP',
  AUTOMATIC_CALCULATION_FROM_CRON = 'AUTOMATIC_CALCULATION_FROM_CRON',
  AUTOMATIC_CALCULATION_VIA_CMAWEB = 'AUTOMATIC_CALCULATION_VIA_CMAWEB',
  EXTERNAL_CARRIER = 'EXTERNAL_CARRIER',
  THIRD_PARTY = 'THIRD_PARTY',
  TMS_BLUEYONDER = 'TMS_BLUEYONDER',
  CARRIER = 'CARRIER',
  FOURKITES = 'FOURKITES',
  UNKNOWN = 'UNKNOWN'
}

export class DeliveryEtaEventInitiatorUtil {

  public static fromEmitterAndSource(emitter: EtaEmitter, source: DeliveryEventSource) {
    switch (emitter) {
      case EtaEmitter.DRIVER:
        switch (source) {
          case DeliveryEventSource.CMA:
            return DeliveryEtaEventInitiator.DRIVER_VIA_CMA;
          case DeliveryEventSource.CICO:
            return DeliveryEtaEventInitiator.DRIVER_VIA_CICO;
          case DeliveryEventSource.CICO_TABLET:
            return DeliveryEtaEventInitiator.DRIVER_VIA_CICO;
          default:
            return DeliveryEtaEventInitiator.DRIVER;
        }
      case EtaEmitter.CMBL_AUTOMATIC_ETA:
        switch (source) {
          case DeliveryEventSource.CRON:
            return DeliveryEtaEventInitiator.AUTOMATIC_CALCULATION_FROM_CRON;
          case DeliveryEventSource.CMA:
            return DeliveryEtaEventInitiator.AUTOMATIC_VIA_CMA;
          case DeliveryEventSource.CICO:
            return DeliveryEtaEventInitiator.AUTOMATIC_VIA_CICO;
          case DeliveryEventSource.CICO_TABLET:
            return DeliveryEtaEventInitiator.AUTOMATIC_VIA_CICO;
          default:
            return DeliveryEtaEventInitiator.AUTOMATIC_CALCULATION_VIA_CMAWEB; // We think the only other source is CMAWEB
        }
      case EtaEmitter.SAP_PLANNING_PRELOADED:
        return DeliveryEtaEventInitiator.STATIC_FROM_SAP;
      case EtaEmitter.SAP_PGI:
        return DeliveryEtaEventInitiator.PGI_FROM_SAP;
      case EtaEmitter.EXTERNAL:
        return DeliveryEtaEventInitiator.EXTERNAL_CARRIER
      case EtaEmitter.TMS_BLUEYONDER:
        return DeliveryEtaEventInitiator.TMS_BLUEYONDER
      case EtaEmitter.CARRIER:
        return DeliveryEtaEventInitiator.CARRIER
      case EtaEmitter.FOURKITES:
        return DeliveryEtaEventInitiator.FOURKITES;
      default:
        return DeliveryEtaEventInitiator.UNKNOWN;
    }
  }
}
